import { Address, ContactInfo } from "../../../redux/vmsApi";


export const createStakeholderModel = {
    formId: 'stakeholderForm',
    formField: {
        name: {
            name: 'name',
            label: 'Stakeholder Name',
            requiredErrorMsg: 'Stakeholder name is required',
        },
        type: {
            name: 'type',
            label: 'Stakeholder Type',
            requiredErrorMsg: 'Stakeholder type is required',
        },
        tin: {
            name: 'tin',
            label: 'Tax Identification Number (TIN)',
        },
        VATNumber: {
            name: 'VATNumber',
            label: 'VAT Number Number (VATNumber)',
        },
        paymentTerms: {
            name: 'paymentTerms',
            label: 'Payment Terms',
        },
        supplierCode: {
            name: 'supplierCode',
            label: 'Supplier Code',
        },
        customerCode: {
            name: 'customerCode',
            label: 'Customer Code',
        },
        gender: {
            name: 'customerCode',
            label: 'Customer Code',
        },
        productCategories: {
            name: 'productCategories',
            label: 'Product Categories',
        },
        contactInfo: {
            name: 'items',
            label: 'Requisition Items',
            required: true,
            requiredErrorMsg: 'At least one item is required',
            fields: {
                email: {
                    name: 'contactInfo.email',
                    label: 'Email',
                    requiredErrorMsg: 'Email is required',
                },
                phone: {
                    name: 'contactInfo.phone',
                    label: 'Phone',
                    requiredErrorMsg: 'Phone number is required',
                },
                contactPerson: {
                    name: 'contactInfo.contactPerson',
                    label: 'Contact Person',
                },
            }
        },
        address: {
            street: {
                name: 'address.street',
                label: 'Street',
                requiredErrorMsg: 'Street is required',
            },
            city: {
                name: 'address.city',
                label: 'City',
                requiredErrorMsg: 'City is required',
            },
            country: {
                name: 'address.country',
                label: 'Country',
            },
        },
        rating: {
            name: 'rating',
            label: 'Rating',
        },
        orderHistory: {
            name: 'orderHistory',
            label: 'Order History',
        },
        preferences: {
            name: 'preferences',
            label: 'Preferences',
        },
    },
    initialValues: {
        name: '',
        type: '',
        tin: '',
        VATNumber:'',
        paymentTerms: '',
        supplierCode: '',
        customerCode: '',
        productCategories: [],
        contactInfo: [  
            {
            email: '',
            phone:'',
            contactPerson: ''}],
        address: [{
            street: '',
            city: '',
            country: '',
        }],
        rating: undefined,
        isInternational: false,
        bankingDetailsVerified: false,
        orderHistory: [],
        preferences: {},
    },
};

export type createStakeholderModelType = {
    name: string;
    type: string;
    tin?: string;
    VATNumber?:string;
    paymentTerms?: string;
    supplierCode?: string;
    customerCode?: string;
    gender?: string;
    productCategories?: string[];
    contactInfo: ContactInfo[];
    address: Address[];
    rating?: number;
    isInternational?: boolean;
    bankingDetailsVerified?: boolean;
    orderHistory?: object[];
    preferences?: object;
}



export default createStakeholderModel;
